export { createSvgIcon as default } from '@material-ui/core/utils';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/utils/createSvgIcon.js
// module id = 1
// module chunks = 2